import { useQuery } from '@tanstack/react-query';

import { EQueryKeys } from '../constants/enums';
import useAxios from '../hooks/useAxios';

import { fetchConfig } from './api.utils';

export interface AttributeNamesResponseDto {
  attributeNames: string[];
}

interface UseAnalyticsAttributeNamesParams {
  publisherId?: string;
  startDate: string;
  endDate: string;
}

export function useAnalyticsAttributeNames({ 
  publisherId, 
  startDate, 
  endDate 
}: UseAnalyticsAttributeNamesParams) {
  const axios = useAxios();

  return useQuery({
    ...fetchConfig.general,
    queryKey: [`${EQueryKeys.ANALYTICS_ATTRIBUTES}_NAMES_${startDate}_${endDate}`],
    queryFn: async () => {
      if (!startDate || !endDate) {
        return { attributeNames: [] };
      }

      const data = await axios.get(
        '/dashboard/analytics/attributes/names',
        {
          startDate,
          endDate
        },
        publisherId ? { 'x-publishers': publisherId } : undefined
      );

      return data;
    },
    enabled: !!publisherId && !!startDate && !!endDate
  });
} 